import type { Action } from "../../actions/types";
import { QR_CODE_CHANNEL } from "../../constants";
import { Referral } from "./index";

export const initialState = {};
type StoreState = Referral | {};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (
    action.type === "GET_REFERRAL_SUCCESS" &&
    action.data &&
    action.data.channel === QR_CODE_CHANNEL
  ) {
    return { ...state, ...action.response.data };
  }

  return state;
}
